var map = {
	"./": "06af",
	"./articles": "3a9c",
	"./articles.json": "3a9c",
	"./documents": "29c8",
	"./documents.json": "29c8",
	"./index": "06af",
	"./index.json": "06af",
	"./index_es": "e19c",
	"./index_es.json": "e19c",
	"./linkurious": "1384",
	"./linkurious.json": "1384",
	"./regions": "7a59",
	"./regions.json": "7a59",
	"./worldmap": "972d",
	"./worldmap.json": "972d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6242";